import { useQueue } from '../../../hooks/useQueue.js';

const randomId = () => Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
const useNotifications = ({
  limit
}) => {
  const {
    state,
    queue,
    update,
    cleanQueue
  } = useQueue({
    initialValues: [],
    limit
  });
  const showNotification = notification => {
    const id = notification.id || randomId();
    update(notifications => {
      if (notification.id && notifications.some(n => n.id === notification.id)) {
        return notifications;
      }
      return [...notifications, {
        ...notification,
        id
      }];
    });
    return id;
  };
  const updateNotification = (id, notification) => update(notifications => {
    const index = notifications.findIndex(n => n.id === id);
    if (index === -1) {
      return notifications;
    }
    const newNotifications = [...notifications];
    newNotifications[index] = notification;
    return newNotifications;
  });
  const hideNotification = id => update(notifications => notifications.filter(notification => {
    if (notification.id === id) {
      typeof notification.onClose === 'function' && notification.onClose(notification);
      return false;
    }
    return true;
  }));
  const clean = () => update(() => []);
  return {
    notifications: state,
    queue,
    showNotification,
    updateNotification,
    hideNotification,
    cleanQueue,
    clean
  };
};

export { useNotifications };
